/*
 * Copyright 2025 coze-dev Authors
 * Modifications Copyright 2026 Bytefinger Technology (HK) Co., Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { requestTraceWithRetry } from './trace-query-retry';
import ObQueryApiService from './idl/ob_query_api';
import { axiosInstance, type BotAPIRequestConfig } from './axios';

export const obQueryApi = new ObQueryApiService<BotAPIRequestConfig>({
  request: (params, config = {}) => {
    const headers = {
      'Agw-Js-Conv': 'str',
    };
    const request = () =>
      axiosInstance.request({ ...params, ...config, headers });
    return requestTraceWithRetry(params.url ?? '', request, config.signal);
  },
});
